export default {
  GET_USERS: state => state.users,
  GET_USERS_LIST: state => state.users_list,
  GET_USER: state => state.one_user,
  GET_ROLES: state => state.roles,
}
